var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('button', {
    staticClass: "text-center inline-flex items-center",
    class: _vm.titleClass,
    attrs: {
      "id": _vm.dropdownId,
      "data-dropdown-placement": _vm.placement,
      "data-dropdown-toggle": _vm.dropdownContentId,
      "type": "button"
    }
  }, [_vm.leftIconClass ? _c('i', {
    staticClass: "ml-2",
    class: _vm.leftIconClass
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.title) + " "), _vm.iconClass ? _c('i', {
    staticClass: "ml-1",
    class: _vm.iconClass
  }) : _vm._e()]), _c('div', {
    staticClass: "hidden z-10 w-44 bg-white rounded divide-y divide-gray-100 ring-1 ring-black ring-opacity-5 rounded-md shadow-lg bg-white",
    class: _vm.containerClass,
    attrs: {
      "id": _vm.dropdownContentId
    }
  }, [_c('ul', {
    staticClass: "py-1 text-sm text-gray-700",
    attrs: {
      "aria-labelledby": _vm.dropdownId
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      staticClass: "block py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white",
      class: _vm.itemClass,
      on: {
        "click": function ($event) {
          return _vm.onItemClick(item);
        }
      }
    }, [item.imageUrl ? _c('img', {
      staticClass: "inline",
      staticStyle: {
        "height": "24px"
      },
      attrs: {
        "src": item.imageUrl,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.text) + " ")])]);
  }), 0)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }